goog.provide('yext.m4.errors.DiagnosticData');

yext.m4.errors.DiagnosticData = {

  /**
   * @param {!Object} jsonDiagnostic
   * @return {!yext.m4.errors.DiagnosticData.Diagnostic}
   */
  fromJSONDiagnostic: jsonDiagnostic => {
    let fileLocation;
    if (jsonDiagnostic['fileLocation']) {
      let coordinate;
      if (jsonDiagnostic['fileLocation']['coordinate']) {
        coordinate = new yext.m4.errors.DiagnosticData.Coordinate(
          jsonDiagnostic['fileLocation']['coordinate']['row'],
          jsonDiagnostic['fileLocation']['coordinate']['column'],
        );
      } else {
        coordinate = new yext.m4.errors.DiagnosticData.Coordinate(0, 0);
      }
      fileLocation = new yext.m4.errors.DiagnosticData.FileLocation(
        jsonDiagnostic['fileLocation']['filePath'],
        coordinate,
      );
    }
    return new yext.m4.errors.DiagnosticData.Diagnostic(
      jsonDiagnostic['message'],
      fileLocation,
      Math.ceil(Math.random() * 100000),
    );
  },

  Diagnostic: class {
    /**
     * @param {!string} message
     * @param {!yext.m4.errors.DiagnosticData.FileLocation|undefined} fileLocation
     * @param {!number} id
     */
    constructor(message, fileLocation, id) {
      this.message = message;
      this.fileLocation = fileLocation;
      this.id = id;
    }
  },

  FileLocation: class {
    /**
     * @param {!string} filePath
     * @param {!yext.m4.errors.DiagnosticData.Coordinate} coordinate
     */
    constructor(filePath, coordinate) {
      this.filePath = filePath;
      this.coordinate = coordinate;
    }
  },

  Coordinate: class {
    /**
     * @param {!number} row
     * @param {!number} column
     */
    constructor(row, column) {
      this.row = row;
      this.column = column;
    }
  },
};
